type TLinkSize = 'small' | 'large';
export const getLinkSize = (smallFactor: boolean): TLinkSize =>
  smallFactor ? 'large' : 'small';
